import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building, Users, Award } from 'lucide-react';
import Layout from '../components/layout/Layout';
import { clients } from '../data/mock';
import '../styles/pages.css';
import usePageMeta from '../hooks/usePageMeta';

const Clients = () => {
  usePageMeta({
    title: 'Clientes',
    description: 'Empresas e instituciones que confían en la metodología de SOEM Partners Group para la seguridad de sus eventos.',
    path: '/clients',
  });

  return (
    <Layout>
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Clientes y Experiencia</h1>
          <p>Confianza construida a través de resultados</p>
        </div>
      </section>

      {/* Experience */}
      <section className="section">
        <div className="container">
          <div className="intro-content">
            <p className="lead-text">{clients.experience}</p>
          </div>
        </div>
      </section>

      {/* Sectors */}
      <section className="section section-alt">
        <div className="container">
          <div className="clients-grid">
            <div className="clients-section">
              <div className="clients-icon">
                <Building size={32} />
              </div>
              <h3>Sectores Atendidos</h3>
              <ul className="clients-list">
                {clients.sectors.map((sector, index) => (
                  <li key={index}>{sector}</li>
                ))}
              </ul>
            </div>
            <div className="clients-section">
              <div className="clients-icon">
                <Users size={32} />
              </div>
              <h3>Tipos de Clientes</h3>
              <ul className="clients-list">
                {clients.clientTypes.map((type, index) => (
                  <li key={index}>{type}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Trust */}
      <section className="section">
        <div className="container">
          <div className="trust-box">
            <div className="trust-icon">
              <Award size={48} />
            </div>
            <h3>Confidencialidad y Discreção</h3>
            <p>
              Por la naturaleza de nuestros servicios y el perfil de nuestros clientes, 
              mantenemos estricta confidencialidad sobre los proyectos específicos en 
              los que participamos.
            </p>
            <p>
              La discreção es parte fundamental de nuestra propuesta de valor. 
              Nuestros clientes confían en que su información y la de sus eventos 
              será tratada con el más alto nivel de reserva.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Únase a nuestros clientes</h2>
            <p>
              Descubra por qué organizaciones líderes confían en SOEM Partners Group 
              para la seguridad de sus eventos más importantes.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Iniciar conversación
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Clients;
